import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import { CastAdminData, CreateAssignmentData } from '@api/casting.api.ts';

export interface CastingState extends CallStateMethods {
  callState: CallStateEnum;
  data: CastAdminData | null;
  castGatewayUrl: string;
  lastRefresh: Date | null;
  assignmentLoading: boolean;
  getCastData: () => Promise<void>;
  refreshCastData: () => Promise<void>;
  assignChromecast: (data: CreateAssignmentData) => Promise<boolean>;
  unassignChromecast: (chromecastUuid: string) => Promise<boolean>;
}

export interface CastingStateMethods extends CallStateMethodNames {
  getCastData: 'getCastData';
  refreshCastData: 'refreshCastData';
  assignChromecast: 'assignChromecast';
  unassignChromecast: 'unassignChromecast';
}

export const CASTING_INITIAL_STATE: Omit<
  CastingState,
  keyof CastingStateMethods
> = {
  callState: CallStateEnum.Init,
  data: null,
  castGatewayUrl: 'http://localhost:4008',
  lastRefresh: null,
  assignmentLoading: false
};
